import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="handler-validator"
export default class extends Controller {
	static targets = ["input", "feedback"];
	static classes = ["valid", "invalid"];
	static values = { pattern: String, minLength: Number, maxLength: Number, labels: Object };

	connect() {
		this.validate();
	}

	validate() {
		const value = this.inputTarget.value;
		const cleanedValue = value.toLowerCase().replace(/\s/g, "");

		// Enforce lowercase and remove whitespace as user types
		if (value !== cleanedValue) {
			// Store cursor position
			const cursorPosition = this.inputTarget.selectionStart;
			this.inputTarget.value = cleanedValue;
			// Restore cursor position (adjust for removed characters)
			const removedChars = value.length - cleanedValue.length;
			const newPosition = Math.max(0, cursorPosition - removedChars);
			this.inputTarget.setSelectionRange(newPosition, newPosition);
		}

		// Validate using shared constants from Rails
		const validPattern = new RegExp(this.patternValue);
		const isValid = cleanedValue.length >= this.minLengthValue && cleanedValue.length <= this.maxLengthValue && validPattern.test(cleanedValue);

		this.updateFeedback(cleanedValue, isValid);
	}

	updateFeedback(value, isValid) {
		if (!this.hasFeedbackTarget) return;

		// Clear existing classes
		this.inputTarget.classList.remove(...this.validClasses, ...this.invalidClasses);
		this.feedbackTarget.classList.remove(...this.validClasses, ...this.invalidClasses);

		if (value.length === 0) {
			// Empty state - no feedback
			this.feedbackTarget.textContent = "";
			return;
		}

		if (isValid) {
			this.inputTarget.classList.add(...this.validClasses);
			this.feedbackTarget.classList.add(...this.validClasses);
			this.feedbackTarget.textContent = `✓ ${this.labelsValue.valid}`;
		} else {
			this.inputTarget.classList.add(...this.invalidClasses);
			this.feedbackTarget.classList.add(...this.invalidClasses);

			// Provide specific error messages
			if (value.length < this.minLengthValue) {
				this.feedbackTarget.textContent = `✗ ${this.labelsValue.too_short.replace("%{min}", this.minLengthValue)}`;
			} else if (value.length > this.maxLengthValue) {
				this.feedbackTarget.textContent = `✗ ${this.labelsValue.too_long.replace("%{max}", this.maxLengthValue)}`;
			} else if (!new RegExp(this.patternValue).test(value)) {
				this.feedbackTarget.textContent = `✗ ${this.labelsValue.invalid_chars}`;
			} else {
				this.feedbackTarget.textContent = `✗ ${this.labelsValue.invalid_format}`;
			}
		}
	}
}
